import { toast } from 'sonner';
import type { UserInfoOnboardingData } from '@/components/dialogs/user-info-onboarding-dialog';
import { sanitizeFreeText } from '@/modules/analytics';
import type { Services } from '@/infrastructure/services';

export async function saveOnboardingAnswers(services: Services, userId: string, data: UserInfoOnboardingData) {
  const persona =
    data.roleCategory === 'other'
      ? (data.roleOtherText ?? '').trim()
      : data.roleCategory === 'spatially_curious'
        ? 'spatially_curious'
        : data.roleCategory;
  const commercial_intent = data.businessUse;
  const discovery_source =
    data.discoverySource === 'other'
      ? (data.discoveryOtherText ?? '').trim()
      : data.discoverySource;
  try {
    await services.organization.updateOrgMember(userId, {
      persona,
      commercial_intent,
      discovery_source
    });
  } catch (error) {
    toast.error("Couldn't save your answers. Please try again.");
    throw error;
  }
  services.analytics.trackLureoOnboardingInfoSubmitted({
    role_category: data.roleCategory,
    business_use: data.businessUse,
    discovery_source: data.discoverySource,
    role_other_text: sanitizeFreeText(data.roleOtherText),
    discovery_source_other: sanitizeFreeText(data.discoveryOtherText)
  });
}
